import { ACTIVE, DELETED, INSTRUMENT_TYPE_BONDS, INSTRUMENT_TYPE_CRYPTO, INSTRUMENT_TYPE_CURRENCY, 
  INSTRUMENT_TYPE_EQUITY, INSTRUMENT_TYPE_ETF, INSTRUMENT_TYPE_FUTURES, INSTRUMENT_TYPE_INDEX, 
  INSTRUMENT_TYPE_NAME_BONDS, INSTRUMENT_TYPE_NAME_CRYPTO, INSTRUMENT_TYPE_NAME_CURRENCY, 
  INSTRUMENT_TYPE_NAME_EQUITY, INSTRUMENT_TYPE_NAME_ETF, INSTRUMENT_TYPE_NAME_FUTURES, 
  INSTRUMENT_TYPE_NAME_INDEX, INSTRUMENT_TYPE_NAME_WARRANT, INSTRUMENT_TYPE_UNKNOWN, INSTRUMENT_TYPE_WARRANT, 
  NAME_UNKNOWN, 
  STATUS_ACTIVE, STATUS_DELETED, STATUS_SUSPEND, STATUS_TRIGGERED, SUSPENDED, TRADING_RULES_APPROVAL_HOLDINGS_CHECK, TRADING_RULES_BOTH, TRADING_RULES_FULL_HOLDINGS_CHECK, TRADING_RULES_NAME_APPROVAL_HOLDINGS_CHECK, TRADING_RULES_NAME_BOTH, TRADING_RULES_NAME_FULL_HOLDINGS_CHECK, NAME_NO, TRADING_RULES_NAME_PARENT_HOLDINGS_CHECK, NAME_YES, NO, TRADING_RULES_PARENT_HOLDINGS_CHECK, YES, TRIGGERED, 
  AUCTION_CLOSE,
  AUCTION_LAST,
  AUCTION_OPEN,
  NAME_AUCTION_LAST,
  NAME_AUCTION_OPEN,
  NAME_AUCTION_CLOSE,
  NAME_AUCTION_NONE,
  AUCTION_NONE,
  TRADING_RULES_NAME_NONE,
  TRADING_RULES_NAME_ONE_SIDE,
  TRADING_RULES_ONE_SIDE,
  NAME_POST_FUNCTION_CLOSE_IS_LAST_AUCTION_PRICE,
  POST_FUNCTION_CLOSE_IS_LAST_AUCTION_PRICE,
  NAME_POST_FUNCTION_CLOSE_IS_LTP,
  POST_FUNCTION_CLOSE_IS_LTP,
  NAME_POST_FUNCTION_CLOSE_IS_VWAP,
  POST_FUNCTION_CLOSE_IS_VWAP,
  NAME_POST_FUNCTION_NOT_SET,
  SESSION_TYPE_NOT_SET,
  SESSION_TYPE_PREOPEN,
  SESSION_TYPE_OPEN,
  SESSION_TYPE_CLOSE,
  SESSION_TYPE_AUCTION,
  SESSION_TYPE_OTHER,
  NAME_SESSION_TYPE_NOT_SET,
  NAME_SESSION_TYPE_PREOPEN,
  NAME_SESSION_TYPE_OPEN,
  NAME_SESSION_TYPE_CLOSE,
  NAME_SESSION_TYPE_AUCTION,
  NAME_SESSION_TYPE_OTHER,
  POST_FUNCTION_NOT_SET,
  INDEX_NAME_CALCULATION_TYPE_LTP,
  INDEX_CALCULATION_TYPE_LTP,
  INDEX_NAME_CALCULATION_TYPE_VWAP,
  INDEX_CALCULATION_TYPE_VWAP} from "./common";

export function ConvertToInstrumentTypeId(type) {
  switch (type) {
    case INSTRUMENT_TYPE_NAME_EQUITY:
      return INSTRUMENT_TYPE_EQUITY;
    case INSTRUMENT_TYPE_NAME_CRYPTO:
      return INSTRUMENT_TYPE_CRYPTO;
    case INSTRUMENT_TYPE_NAME_BONDS:
      return INSTRUMENT_TYPE_BONDS;
    case INSTRUMENT_TYPE_NAME_FUTURES:
      return INSTRUMENT_TYPE_FUTURES;
    case INSTRUMENT_TYPE_NAME_INDEX:
      return INSTRUMENT_TYPE_INDEX;
    case INSTRUMENT_TYPE_NAME_ETF:
      return INSTRUMENT_TYPE_ETF;
    case INSTRUMENT_TYPE_NAME_WARRANT:
      return INSTRUMENT_TYPE_WARRANT;
    case INSTRUMENT_TYPE_NAME_CURRENCY:
      return INSTRUMENT_TYPE_CURRENCY;      
    default:
      return INSTRUMENT_TYPE_UNKNOWN;
  }
};

export function ConvertToTradingEventStatusId(status) { 
  switch (status) {
    case ACTIVE:
      return STATUS_ACTIVE;
    case SUSPENDED:
      return STATUS_SUSPEND;
    case DELETED:
      return STATUS_DELETED;
    case TRIGGERED:
      return STATUS_TRIGGERED;
    default:
      return '';
  }
}

export function ConvertFromTradingEventStatusId(status) { 
  switch (status) {
    case STATUS_ACTIVE:
      return ACTIVE;
    case STATUS_SUSPEND:
      return SUSPENDED;
    case STATUS_DELETED:
      return DELETED;
    case STATUS_TRIGGERED:
      return TRIGGERED;
    default:
      return '';
  }
}


export function ConvertFromPostFunction(type) { 
  switch (type) {
    case POST_FUNCTION_CLOSE_IS_LAST_AUCTION_PRICE:
      return NAME_POST_FUNCTION_CLOSE_IS_LAST_AUCTION_PRICE;
    case POST_FUNCTION_CLOSE_IS_LTP:
      return NAME_POST_FUNCTION_CLOSE_IS_LTP;
    case POST_FUNCTION_CLOSE_IS_VWAP:
      return NAME_POST_FUNCTION_CLOSE_IS_VWAP;
    case POST_FUNCTION_NOT_SET:
      return NAME_POST_FUNCTION_NOT_SET;
    default:
      return NAME_POST_FUNCTION_NOT_SET;
  }
}

export function ConvertToPostFunction(type) { 
  switch (type) {
    case NAME_POST_FUNCTION_CLOSE_IS_LAST_AUCTION_PRICE:
      return POST_FUNCTION_CLOSE_IS_LAST_AUCTION_PRICE;
    case NAME_POST_FUNCTION_CLOSE_IS_LTP:
      return POST_FUNCTION_CLOSE_IS_LTP;
    case NAME_POST_FUNCTION_CLOSE_IS_VWAP:
      return POST_FUNCTION_CLOSE_IS_VWAP;
    case NAME_POST_FUNCTION_NOT_SET:
      return POST_FUNCTION_NOT_SET;
    default:
      return POST_FUNCTION_NOT_SET;
  }
}

export function ConvertFromPreFunction(type) { 
  switch (type) {
    case POST_FUNCTION_NOT_SET:
      return NAME_POST_FUNCTION_NOT_SET;
    default:
      return NAME_POST_FUNCTION_NOT_SET;
  }
}

export function ConvertToPreFunction(type) { 
  switch (type) {
    case NAME_POST_FUNCTION_NOT_SET:
      return POST_FUNCTION_NOT_SET;
    default:
      return POST_FUNCTION_NOT_SET;
  }
}

export function ConvertFromAuctionType(type) { 
  switch (type) {
    case AUCTION_CLOSE:
      return NAME_AUCTION_CLOSE;
    case AUCTION_OPEN:
      return NAME_AUCTION_OPEN;
    case AUCTION_LAST:
      return NAME_AUCTION_LAST;
    default:
      return NAME_AUCTION_NONE;
  }
}

export function ConvertToAuctionType(type) { 
  switch (type) {
    case NAME_AUCTION_CLOSE:
      return AUCTION_CLOSE;
    case NAME_AUCTION_OPEN:
      return AUCTION_OPEN;
    case NAME_AUCTION_LAST:
      return AUCTION_LAST;
    default:
      return AUCTION_NONE;
  }
}

export function ConvertFromSessionType(type) { 
  switch (type) {
    case SESSION_TYPE_NOT_SET:
      return NAME_SESSION_TYPE_NOT_SET;
    case SESSION_TYPE_PREOPEN:
      return NAME_SESSION_TYPE_PREOPEN;
    case SESSION_TYPE_OPEN:
      return NAME_SESSION_TYPE_OPEN;
    case SESSION_TYPE_CLOSE:
      return NAME_SESSION_TYPE_CLOSE;
    case SESSION_TYPE_AUCTION:
      return NAME_SESSION_TYPE_AUCTION;
    case SESSION_TYPE_OTHER:
      return NAME_SESSION_TYPE_OTHER;
    default:
      return NAME_SESSION_TYPE_NOT_SET;
  }
}

export function ConvertToSessionType(type) { 
  switch (type) {
    case NAME_SESSION_TYPE_NOT_SET:
      return SESSION_TYPE_NOT_SET;
    case NAME_SESSION_TYPE_PREOPEN:
      return SESSION_TYPE_PREOPEN;
    case NAME_SESSION_TYPE_OPEN:
      return SESSION_TYPE_OPEN;
    case NAME_SESSION_TYPE_CLOSE:
      return SESSION_TYPE_CLOSE;
    case NAME_SESSION_TYPE_AUCTION:
      return SESSION_TYPE_AUCTION;
    case NAME_SESSION_TYPE_OTHER:
      return SESSION_TYPE_OTHER;
    default:
      return SESSION_TYPE_NOT_SET;
  }
}

export function ConvertFromTradingRulesValueName(value) { 
  switch (value) {
    case NAME_YES:
      return YES;
    case NAME_NO:
      return NO;
    case TRADING_RULES_NAME_BOTH:
      return TRADING_RULES_BOTH;
    case TRADING_RULES_NAME_ONE_SIDE:
      return TRADING_RULES_ONE_SIDE;
    case TRADING_RULES_NAME_FULL_HOLDINGS_CHECK:
      return TRADING_RULES_FULL_HOLDINGS_CHECK;
    case TRADING_RULES_NAME_APPROVAL_HOLDINGS_CHECK:
      return TRADING_RULES_APPROVAL_HOLDINGS_CHECK;
    case TRADING_RULES_NAME_PARENT_HOLDINGS_CHECK:
      return TRADING_RULES_PARENT_HOLDINGS_CHECK;
    default:
      return NO;
  }
}

export function ConvertToTradingRulesValueName(value) { 
  switch (value) {
    case YES:
      return NAME_YES;
    case NO:
      return NAME_NO;
    case TRADING_RULES_BOTH:
      return TRADING_RULES_NAME_BOTH;
    case TRADING_RULES_ONE_SIDE:
      return TRADING_RULES_NAME_ONE_SIDE;
    case TRADING_RULES_FULL_HOLDINGS_CHECK:
      return TRADING_RULES_NAME_FULL_HOLDINGS_CHECK;
    case TRADING_RULES_APPROVAL_HOLDINGS_CHECK:
      return TRADING_RULES_NAME_APPROVAL_HOLDINGS_CHECK;
    case TRADING_RULES_PARENT_HOLDINGS_CHECK:
      return TRADING_RULES_NAME_PARENT_HOLDINGS_CHECK;
    default:
      return NAME_UNKNOWN;
  }
}

export function ConvertFromHoldingsValueName(value) { 
  switch (value) {
    case TRADING_RULES_NAME_BOTH:
      return TRADING_RULES_BOTH;
    case TRADING_RULES_NAME_FULL_HOLDINGS_CHECK:
      return TRADING_RULES_FULL_HOLDINGS_CHECK;
    case TRADING_RULES_NAME_APPROVAL_HOLDINGS_CHECK:
      return TRADING_RULES_APPROVAL_HOLDINGS_CHECK;
    case TRADING_RULES_NAME_PARENT_HOLDINGS_CHECK:
      return TRADING_RULES_PARENT_HOLDINGS_CHECK;
    default:
      return NO;
  }
}

export function ConvertToHoldingsValueName(value) { 
  switch (value) {
    case TRADING_RULES_BOTH:
      return TRADING_RULES_NAME_BOTH;
    case TRADING_RULES_FULL_HOLDINGS_CHECK:
      return TRADING_RULES_NAME_FULL_HOLDINGS_CHECK;
    case TRADING_RULES_APPROVAL_HOLDINGS_CHECK:
      return TRADING_RULES_NAME_APPROVAL_HOLDINGS_CHECK;
    case TRADING_RULES_PARENT_HOLDINGS_CHECK:
      return TRADING_RULES_NAME_PARENT_HOLDINGS_CHECK;
    default:
      return TRADING_RULES_NAME_NONE;
  }
}

export function ConvertToCalculationType(value) { 
  switch (value) {
    case INDEX_NAME_CALCULATION_TYPE_LTP:
      return INDEX_CALCULATION_TYPE_LTP;
    case INDEX_NAME_CALCULATION_TYPE_VWAP:
      return INDEX_CALCULATION_TYPE_VWAP;
    default:
      return NAME_UNKNOWN;
  }
}

export function ConvertFromCalculationType(value) { 
  switch (value) {
    case INDEX_CALCULATION_TYPE_LTP:
      return INDEX_NAME_CALCULATION_TYPE_LTP;
    case INDEX_CALCULATION_TYPE_VWAP:
      return INDEX_NAME_CALCULATION_TYPE_VWAP;
    default:
      return NO;
  }
}


export const yesNoOptions = ([
  { id: YES, name: NAME_YES },
  { id: NO, name: NAME_NO },
]);